import axios from "axios"

export function getPackageActivityLog (uuid) {
  return new Promise((resolve, reject) => {
    axios.get(`/distributor/admin/api/v1/inventory/package/stock-activity/${uuid}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};